import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function PrintAllButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} size="md" className="text-success btn-link edit" title={t("common.actions.printAll")} disabled={disabled}>
        <i className={disabled ? "nc-icon nc-paper-2 icon-bold fa-spin" : "nc-icon nc-paper-2 icon-bold"} />
      </Button>
    </div>
  );
}
